import { PageInternalVersion } from '../types/page';

function getIsVersionMigrated(
  currentVersion: PageInternalVersion | undefined,
  targetVersion: PageInternalVersion,
) {
  if (currentVersion === undefined) {
    return false;
  }
  return currentVersion >= targetVersion;
}

export function getAreDepsCreated(pageVersion?: PageInternalVersion) {
  return getIsVersionMigrated(pageVersion, PageInternalVersion.V0);
}
